/**
 * @file コンポーネント：テキストエリア スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledTextarea = styled.textarea`
    padding: 4px 16px;
    border: 1px solid #868686;
    border-radius: 4px;
    background-color: #ffffff;
    color: #575757;
    font-size: 16px;
    line-height: 32px;

    &:read-only {
        color: #acadae;
    }

    &.is-wide {
        width: 100%;
    }
`;
